import { render, staticRenderFns } from "./DkLogin.vue?vue&type=template&id=65439a27&"
import script from "./DkLogin.vue?vue&type=script&lang=js&"
export * from "./DkLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports